import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Lesson } from '@lyceo/homi/shared/util-models';
import * as LessonSelectors from './lesson.selectors';

@Injectable({
  providedIn: 'root',
})
export class LessonFacade {
  private readonly store: Store = inject(Store);

  public readonly allLessons: Signal<Lesson[]> = this.store.selectSignal(
    LessonSelectors.selectAllLessons,
  );
}
